import { curry } from 'ramda';

import { clear } from '../../../helpers/compact';

type PrismicSlice = {
  [key: string]: any;
};

type Slice = {
  type: string;
  [key: string]: any;
};

export type SliceMapper = { [key: string]: (slice: any) => Slice };

const normalizeSlice = (mapper: SliceMapper, slice: PrismicSlice): Slice => {
  if (slice?.primary?.enabled === 'non') {
    return undefined;
  }

  return clear(mapper[slice?.slice_type]?.(slice));
};

/**
 * Normalize a list of prismic slices
 *
 * @param mapper Mapper available to transform the slice
 * @param slices List of prismic slices to normalize
 * @return Normalized slices
 */
export const processSlices = curry(
  (mapper: SliceMapper, slices: PrismicSlice[]): Slice[] =>
    slices?.map((slice) => normalizeSlice(mapper, slice))?.filter(Boolean)
);
